require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-game-of-life-week-2-of-ios-bootcamp.json") })
        }
      }, "path---blog-the-game-of-life-week-2-of-ios-bootcamp");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-game-of-life-week-2-of-ios-bootcamp!./.cache/json/blog-the-game-of-life-week-2-of-ios-bootcamp.json
// module id = 1132
// module chunks = 231608221292675